import { render, staticRenderFns } from "./HubungiKami.vue?vue&type=template&id=1bf292ae"
import script from "./HubungiKami.vue?vue&type=script&lang=js"
export * from "./HubungiKami.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports